import {invoke} from 'lodash';
import {get, isFunction} from 'lodash/fp';

import platformConfig from '/config/platform.config';
import {getInputFontFamily} from '/util/text.util';

export const setNativeInputStyle = (inputEl: any, {hasShowSecureText}: any) => {
  // The "fontFamily" for password field works incorrectly on Android.
  // https://github.com/facebook/react-native/issues/30123
  //
  if (platformConfig.getOS() === 'android' && hasShowSecureText) {
    invoke(inputEl.current, 'setNativeProps', {
      style: getInputFontFamily(),
    });
  }
};

export const getHandler = (
  internalHandler: any,
  externalHandlerPropName: any,
  props: any,
) => {
  const externalHandler = get(externalHandlerPropName)(props);

  return (...evtArgs: any[]) => {
    internalHandler(...evtArgs);

    if (isFunction(externalHandler)) {
      return externalHandler(...evtArgs);
    }
  };
};
